const formatCurrency = (
  number,
  decimalPlaces = 2,
  decimalSeparator = '.',
  thousandSeparator = '',
) => {
  const absDecimalPlaces = Math.abs(decimalPlaces);
  const places = Number.isNaN(absDecimalPlaces) ? 2 : absDecimalPlaces;
  const decSep = decimalSeparator === undefined ? '.' : decimalSeparator;
  const thouSep = thousandSeparator === undefined ? ',' : thousandSeparator;

  const sign = number < 0 ? '-' : '';
  const fixedNumber = Math.abs(+number || 0).toFixed(places);
  const integerPart = `${parseInt(fixedNumber, 10)}`;
  const separatorPosition = integerPart.length > 3 ? integerPart.length % 3 : 0;

  return (
    sign +
    (separatorPosition
      ? integerPart.substr(0, separatorPosition) + thouSep
      : '') +
    integerPart
      .substr(separatorPosition)
      .replace(/(\d{3})(?=\d)/g, `$1${thouSep}`) +
    (places
      ? decSep +
        Math.abs(number - integerPart)
          .toFixed(places)
          .slice(2)
      : '')
  );
};

const convertToFloatNumber = (value) => {
  const stringValue = value.toString();

  if (stringValue.includes('.') || stringValue.includes(',')) {
    const dotIndex = stringValue.indexOf('.');
    const commaIndex = stringValue.indexOf(',');

    if (dotIndex > commaIndex) {
      return parseFloat(stringValue.replace(/,/g, '.'));
    }
    return parseFloat(stringValue.replace(/\./g, '').replace(/,/g, '.'));
  }
  return parseFloat(stringValue);
};

function formatNumber(value) {
  const floatValue = convertToFloatNumber(value);
  return formatCurrency(floatValue, 2, '.', '');
}

export default formatNumber;
